import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { NavLink as Link } from 'react-router-dom'
import { Creators as FaleConoscoActions } from '_/store/faleConosco'
import SVGLoader from './SVGLoader'

class FaleConosco extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            faleConosco: null,
        }
    }

    componentDidMount() {
        this.props.buscaFaleConosco().then(() => {
            this.setState({
                faleConosco: this.props.faleConosco.lista,
            })
        })
    }

    render() {
        let conteudo = this.props.faleConosco.lista

        return (
            <div className="rodapeFaleConosco">
                <div className="tituloFaleConosco">
                    <span title={conteudo[0] == undefined ? 'Sem configuração...' : conteudo[0].tituloCategoria}>
                        {conteudo[0] == undefined ? 'Sem configuração...' : conteudo[0].tituloCategoria}
                    </span>
                </div>

                <div className="itensRodapeFaleConosco">
                    {conteudo.slice(0, 3).map((item, i) => {
                        return (
                            <div key={i} id={'faleConosco_' + 1} className="itemFaleConosco">
                                <div className="imagemItemFaleConosco">
                                    <SVGLoader imagem={`icones/${item.imagem}`} fallback="icones/settings.png" className="imagemFaleConosco" />
                                </div>
                                <div className="corpoItemFaleConosco">
                                    <div className="tituloItemFaleConosco">{item.tituloSuperior}</div>

                                    {this.renderItem(item, i)}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    renderItem(item, i) {
        switch (item.tipo) {
            case 'serviço':
                return (
                    <div className="mensagemItemFaleConosco">
                        {item.url && item.url.includes('http') ? (
                            <a href={item.url} target="blank">
                                {item.tituloMenu}
                            </a>
                        ) : (
                            <Link to={item.url} title={item.tituloMenu}>
                                {item.tituloMenu}
                            </Link>
                        )}
                    </div>
                )

            case 'atalho':
                return (
                    <div className="mensagemItemFaleConosco">
                        <a href={item.url} target="blank">
                            {item.tituloMenu}
                        </a>
                    </div>
                )

            case 'conteudo':
                let params = {
                    conteudo: item.conteudo,
                    titulo: item.tituloMenu,
                }

                return (
                    <div className="mensagemItemFaleConosco">
                        <Link to={'/conteudoGrupo/' + btoa(encodeURIComponent(JSON.stringify(params)))} title={item.tituloMenu}>
                            {item.tituloMenu}
                        </Link>
                    </div>
                )

            default:
                return <div className="mensagemItemFaleConosco">{item.tituloMenu} </div>
        }
    }
}

const mapStateToProps = state => ({
    faleConosco: state.basico.entidades.faleConosco,
})

const mapDispatchToProps = dispatch => bindActionCreators({ ...FaleConoscoActions }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FaleConosco)
